import { IThongKeSiSoSelectRequest } from '../models/request/thong-ke/IThongKeSiSoSelectRequest';
import { apiClient } from './apiClient';

const withTruongQuery = (path: string, request: IThongKeSiSoSelectRequest) => {
    const dm_truong_id = request.dm_truong_id;
    if (!dm_truong_id || dm_truong_id <= 0) {
        return path;
    }
    return `${path}?dm_truong_id=${encodeURIComponent(dm_truong_id)}`;
}

export const thongKeApi = {
    ThongKeSiSo: (request: IThongKeSiSoSelectRequest) => 
        apiClient.get(withTruongQuery(`thong-ke/co-so/${request.dm_coso_id}/nam-hoc/${request.nam_hoc}/si-so`, request)),
    ThongKeTrangThai: (request: IThongKeSiSoSelectRequest) => 
        apiClient.get(withTruongQuery(`thong-ke/co-so/${request.dm_coso_id}/nam-hoc/${request.nam_hoc}/trang-thai`, request)),
    ThongKeCSKH: (request: IThongKeSiSoSelectRequest) => 
        apiClient.get(withTruongQuery(`thong-ke/co-so/${request.dm_coso_id}/nam-hoc/${request.nam_hoc}/cskh`, request)),
    ThongKeCSKHByMonth: (request: IThongKeSiSoSelectRequest) => 
        apiClient.get(withTruongQuery(`thong-ke/co-so/${request.dm_coso_id}/nam-hoc/${request.nam_hoc}/cskh/by-month`, request)),
    ThongKeCRMByChienDich: (request: IThongKeSiSoSelectRequest) => 
        apiClient.get(withTruongQuery(`thong-ke/co-so/${request.dm_coso_id}/nam-hoc/${request.nam_hoc}/crm/by-chien-dich`, request)),
    ThongKeCRMByNguonBietToi: (request: IThongKeSiSoSelectRequest) => 
        apiClient.get(withTruongQuery(`thong-ke/co-so/${request.dm_coso_id}/nam-hoc/${request.nam_hoc}/crm/by-nguon-biet-toi`, request)),
}

